module.exports = __webpack_public_path__ + "static/media/logo-goodwe-rewards.b9e49a68.svg";